export class InputStateHandler {
  #input;
  /**
   * @type {String|null}
   */
  #manualValue = null;

  constructor(input) {
    if (!(input instanceof HTMLInputElement))
      throw new Error('Input must be an input element!');

    this.#input = input;

    this.#input.addEventListener('paste', ev => this.#OnChanged(ev));
    this.#input.addEventListener('keyup', ev => this.#OnChanged(ev));
  }

  TrySetValue(newValue) {
    if (this.#manualValue !== null && this.#manualValue.length > 0) {
      return false;
    }

    this.#input.value = newValue;
    this.#input.dispatchEvent(new Event('change'));

    return true;
  }

  #OnChanged(ev) {
    if (this.#input.value.length === 0) this.#manualValue = null;
    else this.#manualValue = this.#input.value;
  }
}
